<template>
    <placement>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Job</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-3 sm:col-span-3">

                            <FormMultiselect
                                required
                                label="Company"
                                :options="companies"
                                track-key="id"
                                label-key="name"
                                :object="true"
                                v-model="form.company"
                                :placeholder="'Select Company'"
                                :error="form.errors.company"
                            />
                        </div>
                        <div class="col-span-5 sm:col-span-5">
                            <breeze-label :value="'Job Title'" :required="true"/>
                            <breeze-input required v-model="form.job_title" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.job_title:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Monthly Salary'" :required="true"/>
                            <breeze-input required v-model="form.monthly_salary" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.monthly_salary:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'No of Openings'" :required="true"/>
                            <breeze-input required v-model="form.no_of_openings" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.no_of_openings:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :value="'Job Location'" :required="true"/>
                            <breeze-input required v-model="form.job_location" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.job_location:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :value="'Experience'" :required="true"/>
                            <breeze-input required v-model="form.experience" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.experience:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Date of interview'" :required="true"/>
                            <breeze-input required type="date" v-model="form.date_of_interview" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.date_of_interview:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Valid Till'" :required="true"/>
                            <breeze-input required type="date" v-model="form.valid_till" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.valid_till:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :value="'Criteria'" :required="true"/>
                            <breeze-input required v-model="form.criteria" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.criteria:''"/>
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :value="'Additional Details'"/>
                            <breeze-input v-model="form.additional_details" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.additional_details:''"/>
                        </div>
                        <div>
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''"/>
                        </div>
                    </div>
                    <button-link :href="route('placement.job.list')" class="bg-red-500 mr-4 hover:bg-red-400">Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Update</breeze-button>
                    <exception/>
                </form>
            </div>
        </div>
    </placement>
</template>

<script>
import Placement from '@/Pages/Placement/Placement'
import BreezeTable from '@/Components/Table'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'
import SelectList from '@/Components/SelectList'
import Exception from '@/Components/Exception'
import {useForm} from '@inertiajs/inertia-vue3'
import Loading from '@/Components/Loading'
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Placement,
        BreezeTable,
        ButtonLink,
        Exception,
        BreezeInputError,
        BreezeInput,
        BreezeLabel,
        BreezeButton,
        Loading,
        SelectList,
        BreezeCheckbox
    },
    props: ['job', 'companies'],
    data() {
        return {
            form: useForm({
                '_method': 'PUT',
                company: this.job.company,
                job_title: this.job.job_title,
                monthly_salary: this.job.monthly_salary,
                no_of_openings: this.job.no_of_openings,
                job_location: this.job.job_location,
                experience: this.job.experience,
                date_of_interview: this.job.date_of_interview,
                valid_till: this.job.valid_till,
                additional_details: this.job.additional_details,
                criteria: this.job.criteria,
                status: this.job.status,
            }),
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('placement.job.update', this.job.id), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
    },

}
</script>
